import {  useForm } from 'react-hook-form';
import { FormInput } from '../../../wrappers/formInput';
import Button from '../../../components/button';
import { yupResolver } from '@hookform/resolvers/yup';
import Styles from "../styles.module.scss";
import * as Yup from 'yup';
import { PhoneInput } from '../../../wrappers/phoneInput';
// import { PhoneInput } from '../../../wrappers/phoneInput';
import { DropDownInput } from "../../../wrappers/selectInput";
import { Icon } from '@iconify/react';
import { useState } from 'react';

export type SignupFormFields = {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  password: any;
  role: any;
}

interface Props {

  ClickHandler: (event: React.MouseEvent<HTMLButtonElement>) => void
  disable: boolean
  removeMessage: any
}
// let value = /^[a-zA-Z .'-]{8,30}$/;

const validationSchema = Yup.object({
  firstName: Yup.string()
    .required("Field is required")
    .max(35, 'First name should not exceed 35 characters')
    .min(2, 'First name should have a minimum of 2 characters')
    .matches(/^[a-zA-Z\s]+$/, 'Enter a valid First Name'),
  lastName: Yup.string()
    .required("Field is required")
    .max(35, 'Last name should not exceed 35 characters')
    .matches(/^[a-zA-Z\s]+$/, 'Enter a valid Last Name'),
  email: Yup.string()
    .required("Field is required")
    .email('Please provide a valid email address')
  // .matches(/'^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+.[a-zA-Z]{2,4}$', 'ig'/,'Please provide  valid email address')
  ,
  phone: Yup.string()
    .required('Field is required')
     .min(5, 'Invalid Phone Number')
     .max(15,'Invalid Phone Number')
   
   .matches(/(?!'-'$)(?!'+'$)[0-9]+$/,'Invalid Phone Number')
  ,
  password: Yup.string()
    .required("Field is required"),
    // .matches(/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#%&])(?=.{8,})/, 'Your password should have min. 8 values and should have an uppercase letter, number and a special character'),
  role: Yup.string().required('Field is required')
});


export const SignupForm: React.FC<Props> = ({
  ClickHandler,
  disable,
  removeMessage,
}) => {

  const formOptions = { resolver: yupResolver(validationSchema) };

  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
  } = useForm<SignupFormFields>(formOptions);

  const [passwordToggle, setPasswordToggle] = useState<boolean>(false)


  const onSubmitForm = (data: any) => { 
    ClickHandler(data) 
  };
  
  return (
    <form >
      <div className="form-group">
        <FormInput<SignupFormFields>
          id="firstName"
          type="text"
          name="firstName"
          label=""
          size="medium"
          placeholder="First Name"
          register={register}
          onchange={(e:any) => e.target.value = ("" + e.target.value.charAt(0)).toUpperCase()+e.target.value.slice(1)}
          errors={errors}
        />
      </div>
      <div className="form-group">
        <FormInput<SignupFormFields>
          id="lastName"
          type="text"
          size="medium"
          name="lastName"
          label=""
          placeholder="Last Name"
          register={register}
          onchange={(e:any) => e.target.value = ("" + e.target.value.charAt(0)).toUpperCase()+e.target.value.slice(1)}
          errors={errors}
        />
      </div>


      <div className="form-group">
      <PhoneInput<SignupFormFields>
        id="phone"
        type="number"
        name="phone"
        label=""
        size="medium"
        register={register}
        errors={errors}
        control={control}
        
      />
     </div>
      {/* <PhoneFiled 
       country={'in'}  
       name = "phone"
       />
      </div> */}
      <div className="form-group">
        <FormInput<SignupFormFields>
          id="email"
          type="email"
          name="email"
          label=""
          size="medium"
          placeholder="Email Address"
          register={register}
          errors={errors}
          onBlur={(e: any) => removeMessage(e.target.value)}
        />
      </div>
      <div className="form-group">
        <div className='password-filed'>
        <FormInput<SignupFormFields>
          id="password"
          type={passwordToggle ? 'text' : 'password'}
          name="password"
          label=""
          size="medium"
          placeholder="Password"
          register={register}
          errors={errors}
        />
        <Icon icon={passwordToggle ? "mdi:eye-off-outline" : "mdi:eye-outline"} className='eye-icon' onClick={() => setPasswordToggle((prev) => !prev)} />
        </div>
      </div>
      <div className="form-group">
        <DropDownInput<SignupFormFields>
          name="role"
          data={["RECRUITER","CS-RECRUITER"]}
          register={register}
          errors={errors}
          control={control}
        />
      </div>
      <Button onClick={handleSubmit(onSubmitForm)} type="submit" variant="primary" size="large" disabled={disable}>Sign Up</Button>
    </form>
  );
};

